<app-spinner>
    <app-sidebar>
        <router-outlet></router-outlet>
    </app-sidebar>
</app-spinner>